// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1_nMs","cls2":"Timer-cls2_P97 Timer-cls1_nMs","mini":"Timer-mini__m6","darkDigits":"Timer-darkDigits_aVQ"};